import React, { useState, useEffect } from "react";
import { Col, Row, FormGroup, Input, Button, Label, Table } from "reactstrap";
import Alert from "react-s-alert";
import { api, constant, dateHelper } from "../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const CycleCountChangeHistory = props => {
  const [warehouseAreas, setWarehouseAreas] = useState([]);
  const [warehouseAreaId, setWarehouseAreaId] = useState(null);
  const [searchTypes, setSearchTypes] = useState([
    constant.inventorySearchType.both,
    constant.inventorySearchType.parts,
    constant.inventorySearchType.products
  ]);
  const [searchType, setSearchType] = useState(
    constant.inventorySearchType.both.id
  );
  const [code, setCode] = useState("");
  const [partialDescription, setPartialDescription] = useState("");
  const [processing, setProcessing] = useState(false);
  const [results, setResults] = useState(null);
  const [cycleCountUsers, setCycleCountUsers] = useState([]);
  const [enteredById, setEnteredById] = useState(null);
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(7, "day")
      .toDate()
  );
  const [endDate, setEndDate] = useState(moment().toDate());

  useEffect(() => {
    api
      .fetch("Reference/WarehouseAreas")
      .then(response => {
        setWarehouseAreas(response.data || []);
      })
      .catch(error =>
        Alert.error("There was an error loading the warehouse areas")
      );
  }, []);

  useEffect(() => {
    api
      .fetch("Warehouse/CycleCountUsers")
      .then(response => {
        setCycleCountUsers(response.data || []);
      })
      .catch(error =>
        Alert.error("There was an error loading the cycle count users")
      );
  }, []);

  const getSearchCriteria = () => {
    return JSON.stringify({
      StartDate:
        startDate ||
        moment()
          .subtract(7, "day")
          .toDate(),
      EndDate: endDate || moment().toDate(),
      InventorySearchType: parseInt(searchType, 10),
      Code: code,
      PartialDescription: partialDescription,
      WarehouseAreaId: warehouseAreaId ? parseInt(warehouseAreaId, 10) : null,
      ChangedByUserId: enteredById ? parseInt(enteredById, 10) : null
    });
  };

  const getResults = () => {
    setProcessing(true);

    api
      .post("Warehouse/CycleCountChangeHistory", getSearchCriteria())
      .then(response => setResults(response.data))
      .catch(() => Alert.error("There was an error getting report results"))
      .finally(() => setProcessing(false));
  };

  const exportToExcel = () => {
    setProcessing(true);

    api
      .postDownloadBinary(
        "Warehouse/CycleCountChangeHistoryExport",
        getSearchCriteria(),
        constant.mimeTypes.xlsx,
        "CycleCountChangeHistoryExport.xlsx"
      )
      .catch(() => Alert.error("There was an error exporting report results"))
      .finally(() => setProcessing(false));
  };

  return (
    <div className="ml-4 mr-4">
      <Row className="pageTitle p-2">
        <Col>
          <h4 className="">Cycle Count Change History</h4>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col xs={2}>
          <FormGroup>
            <Label> Start Date </Label>
            <div>
              <DatePicker
                selected={startDate}
                className="form-control"
                placeholderText="Select a date"
                onChange={date => setStartDate(date)}
              />
            </div>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> End Date </Label>
            <div>
              <DatePicker
                selected={endDate}
                className="form-control"
                placeholderText="Select a date"
                onChange={date => setEndDate(date)}
              />
            </div>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Inventory Type </Label>
            <select
              value={searchType}
              className="form-control"
              onChange={e => setSearchType(e.target.value)}
            >
              {searchTypes.map((x, index) => (
                <option value={x.id} key={`searchType${index}`}>
                  {x.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Warehouse Area </Label>
            <select
              value={warehouseAreaId}
              onChange={e => setWarehouseAreaId(e.target.value)}
              className="form-control"
            >
              <option value="">All</option>
              {warehouseAreas.map((x, index) => (
                <option value={x.id} key={`warehouseArea${index}`}>
                  {x.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Code Starts With </Label>
            <Input value={code} onChange={e => setCode(e.target.value)} />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Description Contains</Label>
            <Input
              value={partialDescription}
              onChange={e => setPartialDescription(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Entered By </Label>
            <select
              value={enteredById}
              onChange={e => setEnteredById(e.target.value)}
              className="form-control"
            >
              <option value="">All</option>
              {cycleCountUsers &&
                cycleCountUsers.map((x, index) => (
                  <option value={x.id} key={`user${index}`}>
                    {x.name}
                  </option>
                ))}
            </select>
          </FormGroup>
        </Col>
        <Col xs={1}>
          <Button
            color="primary"
            disabled={processing}
            style={{ marginTop: "2em" }}
            onClick={() => getResults()}
          >
            Search
          </Button>
        </Col>
        {results &&
          results.length !== undefined &&
          results.length > 0 && (
            <Col xs={9}>
              <Button
                disabled={processing}
                style={{ marginTop: "2em", float: "right" }}
                onClick={() => exportToExcel()}
              >
                Export To Excel
              </Button>
            </Col>
          )}
      </Row>
      <Row className="mt-2">
        <Col xs={12}>
          {results &&
            results.length !== undefined &&
            results.length > 0 && (
              <Table>
                <thead>
                  <tr>
                    <th>SKU / Product Number</th>
                    <th>Description</th>
                    <th>Changed At</th>
                    <th>Lot Number</th>
                    <th>Quantity</th>
                    <th>Expiration Date</th>
                    <th>PO Number</th>
                    <th>Transfer Date</th>
                    <th>Quantity Change</th>
                    <th>Entered By</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((x, index) => (
                    <React.Fragment key={`result-${index}`}>
                      <tr style={{ backgroundColor: "#DCDCDC" }}>
                        <td>{x.code}</td>
                        <td colspan="9">{x.description} </td>
                      </tr>
                      {x.changes.map((y, yindex) => (
                        <tr key={`result-${index}-change{yindex}`}>
                          <td />
                          <td>
                            {`${y.warehouseAreaName} Bay: ${
                              y.warehouseBay
                            } - Bin: ${y.warehouseBin}`}{" "}
                          </td>
                          <td>{dateHelper.localDateTime(y.createdAt)} </td>
                          <td>{y.lotNumber} </td>
                          <td>{y.quantity} </td>
                          <td>{y.expirationDate} </td>
                          <td>{y.poNumber} </td>
                          <td>{y.transferDate} </td>
                          <td>{y.quantityChange} </td>
                          <td>{y.enteredByUserFullName} </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            )}
          {results &&
            results.length !== undefined &&
            results.length === 0 && (
              <p>No results were found with the selected filters</p>
            )}
        </Col>
      </Row>
    </div>
  );
};

export default CycleCountChangeHistory;



// WEBPACK FOOTER //
// ./src/components/CycleCountChangeHistory.js